import type { FC } from "react"
import { createContext } from "react"

type ToastStatus = "unmounted" | "initial" | "open" | "close"
type IDComponent = FC<{ id: string }>

export interface ToastState {
  status: ToastStatus;
  component: IDComponent;
}

// this context holds the state of all of the current toasts
export type ToastsContextValue = Record<string, ToastState>

type ContextType = ToastsContextValue | null

export const ToastsContext = createContext<ContextType>(null)
